export const DASHBOARD_GRANTED_TIME = "@dashboard_gt";
